import * as React from "react";
import "./OtsCloseEventCard.scss";
import "@alaskaairux/auro-icon";
import dayjs from "dayjs";
import "../../../theme/styles.css";

interface OtsCloseEventProps {
  otsCloseEvent: OtsEventReceived;
  onCardClick?: (otsEvent: OtsEventReceived) => void;
}

const getReturnTime = (returnToServiceUTC: string): number => {
  const returnDate = new Date(returnToServiceUTC);
  const currentDate = new Date();
  const differenceInDays = Math.ceil(
    (currentDate.getTime() - returnDate.getTime()) / (1000 * 60 * 60 * 24)
  );

  return differenceInDays;
};

const getOTSdateTime = (outOfServiceDateTimeUTC: string): any => {
  const convertedTime = dayjs.utc(outOfServiceDateTimeUTC).local();
  return `${convertedTime.format("MM/DD/YY")} . ${convertedTime.format(
    "HH:mm"
  )}`;
};

const OtsCloseEventCard: React.FC<OtsCloseEventProps> = ({
  otsCloseEvent,
  onCardClick,
}) => {
  const handleCardClick = () => {
    if (onCardClick) {
      onCardClick(otsCloseEvent);
    }
  };

  return (
    <div className="tileClose" onClick={handleCardClick} role="button" tabIndex={0}
    onKeyDown={(e) => {
      if (e.key === ' ') {
        handleCardClick();
      }
    }}>
      <div className=" aircraft">
        <span className="data-field aircraft-info closed-event-data">
          {otsCloseEvent?.AircraftRegistration}
        </span>
      </div>
      <div className=" station">
        <span className="data-field aircraft-info closed-event-data">
          {otsCloseEvent?.Station}
        </span>
      </div>
      <div className="start-time">
        {getOTSdateTime(otsCloseEvent?.OutOfServiceDateTimeUTC)}
      </div>
      <span className="card-problem-text">{otsCloseEvent?.ProblemText}</span>
    </div>
  );
};
export default OtsCloseEventCard;
